import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Case, CaseType, CaseTypeFlag } from '../models/case/case.interface';
import {
  CreateDataResponse,
  CreateResponse,
  PaginatedData,
  PaginatedDataResponse,
} from '../models/common/common.interface';

@Injectable({
  providedIn: 'root',
})
export class CaseService {
  private _caseData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private http: HttpClient) {}

  getCases(
    filterReq: any
  ): Observable<PaginatedDataResponse<PaginatedData<any>>> {
    const {
      limit,
      offset,
      order_by,
      order_direction,
      search,
      case_type__name,
      subject_full_name,
      case_number,
      client__name,
    } = filterReq;
    let url = `${environment.fireStoreApiUrl}/api/v1/case/?limit=${limit}&offset=${offset}&order_by=${order_by}&order_direction=${order_direction}`;
    if (search) {
      url += `&search=${search}`;
    }
    if (case_type__name) {
      url += `&case_type__name=${case_type__name}`;
    }
    if (subject_full_name) {
      url += `&subject_full_name=${subject_full_name}`;
    }
    if (case_number) {
      url += `&case_number=${case_number}`;
    }
    if (client__name) {
      url += `&client__name=${client__name}`;
    }
    return this.http.get<PaginatedDataResponse<PaginatedData<Case>>>(url);
  }

  getCaseType(
    limit: number,
    offSet: number,
    searchTerm?: string
  ): Observable<CaseType[]> {
    let url = `${environment.fireStoreApiUrl}/api/v1/case-type/?limit=${limit}&offset=${offSet}`;
    if (searchTerm) {
      url = `${environment.fireStoreApiUrl}/api/v1/case-type/?limit=${limit}&offset=${offSet}&search=${searchTerm}`;
    }
    return this.http
      .get<PaginatedDataResponse<PaginatedData<CaseType>>>(url)
      .pipe(
        map(
          (res: PaginatedDataResponse<PaginatedData<CaseType>>) =>
            res?.details?.hits || []
        )
      );
  }

  setCaseData(data: any) {
    if (!data) {
      localStorage.removeItem('case_data');
    } else {
      localStorage.setItem('case_data', JSON.stringify(data));
    }
    this._caseData.next(data);
  }

  getCaseData(): Observable<any> {
    this._caseData.next(
      this._caseData.value || JSON.parse(localStorage.getItem('case_data'))
    );
    return this._caseData.asObservable();
  }

  get caseDataValue() {
    this._caseData.next(
      this._caseData.value || JSON.parse(localStorage.getItem('case_data'))
    );
    return this._caseData.value;
  }

  getCaseTypeFlags(
    limit: number,
    offSet: number,
    caseTypeId: number,
    searchTerm?: string
  ): Observable<PaginatedDataResponse<PaginatedData<CaseTypeFlag>>> {
    return this.http.get<PaginatedDataResponse<PaginatedData<CaseTypeFlag>>>(
      `${environment.fireStoreApiUrl}/api/v1/${caseTypeId}/flags/?limit=${limit}&offset=${offSet}&search=${searchTerm}`
    );
  }

  createCaseClientInformation(reqBody){
    return this.http.post<CreateDataResponse<CreateResponse<any>>>(
      `${environment.fireStoreApiUrl}/api/v1/client-information/batch-submission/`,
      reqBody
    );
  }

  createCaseLocationInformation(caseId:number,reqBody){
    return this.http.post<CreateDataResponse<CreateResponse<any>>>(
      `${environment.fireStoreApiUrl}/api/v1/location-details/batch-submission/${caseId}/`,
      reqBody
    );
  }

  createCaseSubjectInformation(caseId:number,reqBody){
    return this.http.post<CreateDataResponse<CreateResponse<any>>>(
      `${environment.fireStoreApiUrl}/api/v1/subjects-details/batch-submission/${caseId}/`,
      reqBody
    );
  }
}
